import React from "react";
import PropTypes from "prop-types";

// exported from the package, an app is required to wrap this module in this provider
// A way for the app (gt-web or vms) to inject things that use 'live data'.
// The ET user, or functions that call our Api module that uses some state.

const ChatDependencyContext = React.createContext();

const useChatDependencyContext = () => React.useContext(ChatDependencyContext);

const ChatDependencyProvider = ({ dependencies, children }) => {
  return <ChatDependencyContext.Provider value={dependencies}>{children}</ChatDependencyContext.Provider>;
};

ChatDependencyProvider.propTypes = {
  children: PropTypes.any,
  dependencies: PropTypes.shape({
    app: PropTypes.oneOf(["vms", "core"]).isRequired,
    createDM: PropTypes.func.isRequired,
    addUserToRoom: PropTypes.func.isRequired,
    getPools: PropTypes.func.isRequired,
    searchContacts: PropTypes.func.isRequired,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    oid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    appKey: PropTypes.string.isRequired,
    env: PropTypes.string.isRequired,
    authorization: PropTypes.string.isRequired,
    mixPanelEvents: PropTypes.shape({
      leavePoolChat: PropTypes.func.isRequired,
      globalPlusAdd: PropTypes.func.isRequired,
      startPoolChat: PropTypes.func.isRequired,
      startDM: PropTypes.func.isRequired,
      viewChatPanel: PropTypes.func.isRequired,
    }),
  }),
};

export { ChatDependencyContext, ChatDependencyProvider, useChatDependencyContext };
